// extracted by mini-css-extract-plugin
module.exports = {"strengthSectionContainer":"styles_strengthSectionContainer__ZLSeh"};